import {Skeleton} from '@mui/material';
import Grid from '@mui/material/Grid2';

import {LiveChallengeTemplate} from '../HomePageTemplate/components';

import {ChallenggeItemTemplate} from './components';

import {BackwardTitleTemplate} from '@/components/molecules/BackwardTitleTemplate';

export const ChallengesPageTemplate = () => (
  <>
    <Grid container p={2} spacing={1} size={12}>
      {/******* Backward Title */}
      <Grid size={12}>
        <BackwardTitleTemplate />
      </Grid>
      {/******* Inprogress Games */}
      <Grid container size={12}>
        {/* Title Box: InprogressGames */}
        <Skeleton variant="text" height={20} width={100} />
        {/* Demos*2 */}
        <LiveChallengeTemplate />
        <LiveChallengeTemplate />
      </Grid>
      {/******* Challenges */}
      <Grid container size={12} mt={1}>
        {/* Title Box: Challenges */}
        <Skeleton variant="text" height={20} width={80} />
        {/* ChallengeBigItem */}
        <ChallenggeItemTemplate />
        <ChallenggeItemTemplate />
        <ChallenggeItemTemplate />
      </Grid>
    </Grid>
  </>
);
